module.exports = __webpack_public_path__ + "img/360-interior_ec-phev.67bcf679.jpg";